import React from 'react'
import PropTypes from 'prop-types'
import BasicTable from '../../../../../../atoms/BasicTable'
import Switch from '../../../../../../molecules/Switch'
import SydSelect from '../../../../../../commonDesign/SydSelect'

const DATA_TYPE_OPTIONS = [
  { label: 'integer', value: 'integer' },
  { label: 'string', value: 'string' },
  { label: 'date', value: 'date' },
  { label: 'decimal', value: 'decimal' },
  { label: 'boolean', value: 'boolean' },
  { label: 'json', value: 'json' }
]

function ColumnsDisplay ({ columns, onUpdateColumn }) {
  if (!columns || columns.length === 0) return null

  const editable = typeof onUpdateColumn === 'function'

  return (
    <div style={{ marginBottom: '16px' }}>
      <h4>Columns ({columns.length})</h4>
      <BasicTable className='opal-presentation-table zebra-rows'>
        <thead className='opt-thead'>
          <tr className='opt-tr'>
            <th className='opt-th'>Name</th>
            <th className='opt-th'>Expression</th>
            <th className='opt-th'>Type</th>
            <th className='opt-th'>Filterable</th>
            <th className='opt-th'>Sortable</th>
            <th className='opt-th'>Hidden</th>
            <th className='opt-th'>Faceted</th>
          </tr>
        </thead>
        <tbody className='opt-tbody'>
          {columns.map((col, idx) => (
            <tr className='opt-tr' key={idx}>
              <td className='opt-td'>{col.name}</td>
              <td className='opt-td'>{col.sourceExpression}</td>
              <td className='opt-td'>
                {editable
                  ? (
                    <SydSelect
                      options={DATA_TYPE_OPTIONS}
                      value={col.dataType}
                      onChange={(e) => onUpdateColumn(idx, 'dataType', e.target.value)}
                      size='sm'
                      style={{ minWidth: 0 }}
                      minWidth={0}
                    />
                  )
                  : col.dataType}
              </td>
              <td className='opt-td'>
                {editable
                  ? <Switch checked={!!col.filterable} onChange={() => onUpdateColumn(idx, 'filterable', !col.filterable)} size='small' />
                  : (col.filterable ? 'Yes' : 'No')}
              </td>
              <td className='opt-td'>
                {editable
                  ? <Switch checked={!!col.sortable} onChange={() => onUpdateColumn(idx, 'sortable', !col.sortable)} size='small' />
                  : (col.sortable ? 'Yes' : 'No')}
              </td>
              <td className='opt-td'>
                {editable
                  ? <Switch checked={!!col.hidden} onChange={() => onUpdateColumn(idx, 'hidden', !col.hidden)} size='small' />
                  : (col.hidden ? 'Yes' : 'No')}
              </td>
              <td className='opt-td'>
                {editable
                  ? <Switch checked={!!col.faceted} onChange={() => onUpdateColumn(idx, 'faceted', !col.faceted)} size='small' />
                  : (col.faceted ? 'Yes' : 'No')}
              </td>
            </tr>
          ))}
        </tbody>
      </BasicTable>
    </div>
  )
}

ColumnsDisplay.propTypes = {
  columns: PropTypes.array.isRequired,
  onUpdateColumn: PropTypes.func
}

export default ColumnsDisplay
